// Utility functions for device detection

/**
 * Checks if the current device is a mobile device
 * @returns {boolean} True if the device is mobile, false otherwise
 */
export const isMobile = (): boolean => {
  // Check if window is defined (for SSR)
  if (typeof window === 'undefined') return false;

  // Use matchMedia for a more reliable check
  if (window.matchMedia) {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  // Fallback to user agent check
  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    (window as unknown as { opera?: string }).opera ||
    '';
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  );
};

/**
 * Checks if the current device is a tablet
 * @returns {boolean} True if the device is a tablet, false otherwise
 */
export const isTablet = (): boolean => {
  if (typeof window === 'undefined') return false;

  if (window.matchMedia) {
    return window.matchMedia('(min-width: 768px) and (max-width: 1024px)')
      .matches;
  }

  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    (window as unknown as { opera?: string }).opera ||
    '';
  return /tablet|ipad/i.test(userAgent) && !/mobile/i.test(userAgent);
};

/**
 * Checks if the current device is a desktop
 * @returns {boolean} True if the device is a desktop, false otherwise
 */
export const isDesktop = (): boolean => {
  return !isMobile() && !isTablet();
};
